import {
  extractImagesFromLayer,
  filterMapboxPropsByType,
  normalizeStyle,
  extractLabelImages,
  apiBaseUrl,
  isOffline
} from "../../../js/utils";

// @ts-ignore
import AutoAIM from "../../../../public/icons/toolbox/autoaim.svg";
// @ts-ignore
import MapPin from "../../../../public/icons/toolbox/map-pin.svg";
// @ts-ignore
import MapCheck from "../../../../public/icons/toolbox/map-stop-blue.svg";
// @ts-ignore
import MapMove from "../../../../public/icons/toolbox/map-move.svg";
// @ts-ignore
import MapRotate from "../../../../public/icons/toolbox/map-rotate.svg";
// @ts-ignore
import MapTrash from "../../../../public/icons/toolbox/map-trash.svg";
// @ts-ignore
import MapPinSecondary from "../../../../public/icons/toolbox/map-pin-2.svg";
// @ts-ignore
import GeoRefMapPointWarn from "../../../../public/icons/toolbox/georeference-map-point-warn.svg";
// @ts-ignore
import GeoRefMapPointError from "../../../../public/icons/toolbox/georeference-map-point-error.svg";
// @ts-ignore
import GeoRefMapPointSuccess from "../../../../public/icons/toolbox/georeference-map-point-ok.svg";
// @ts-ignore
import GeoRefCanvasPointWarn from "../../../../public/icons/toolbox/georeference-canvas-point-warn.svg";
// @ts-ignore
import GeoRefCanvasPointError from "../../../../public/icons/toolbox/georeference-canvas-point-error.svg";
// @ts-ignore
import GeoRefCanvasPointSuccess from "../../../../public/icons/toolbox/georeference-canvas-point-ok.svg";

import MapAIM1 from "../../../../public/icons/toolbox/aim1.svg";
import MapAIM2 from "../../../../public/icons/toolbox/aim2.svg";
import MapAIM3 from "../../../../public/icons/toolbox/aim3.svg";
import MapAIM4 from "../../../../public/icons/toolbox/aim4.svg";
import MapAIM5 from "../../../../public/icons/toolbox/aim5.svg";
import MapAIM6 from "../../../../public/icons/toolbox/aim6.svg";
import MapAIM7 from "../../../../public/icons/toolbox/aim7.svg";
import MapAIM8 from "../../../../public/icons/toolbox/aim8.svg";
import MapAIM9 from "../../../../public/icons/toolbox/aim9.svg";
import MapAIM10 from "../../../../public/icons/toolbox/aim10.svg";

import MapAIM11 from "../../../../public/icons/toolbox/aim11.svg";
import MapAIM12 from "../../../../public/icons/toolbox/aim12.svg";
import MapAIM13 from "../../../../public/icons/toolbox/aim13.svg";
import MapAIM14 from "../../../../public/icons/toolbox/aim14.svg";
import MapAIM15 from "../../../../public/icons/toolbox/aim15.svg";
import MapAIM16 from "../../../../public/icons/toolbox/aim16.svg";
import MapAIM17 from "../../../../public/icons/toolbox/aim17.svg";
import MapAIM18 from "../../../../public/icons/toolbox/aim18.svg";
import MapAIM19 from "../../../../public/icons/toolbox/aim19.svg";
import MapAIM20 from "../../../../public/icons/toolbox/aim20.svg";

export class RendererUtils {
  static DocumentTypes = {
    Style: 'style',
    Relief: 'relief',
    Sky: 'Sky',
    Raster: 5,
    TilesService: 11,
    VectorTiles: 17,
    Vector: 4,
    Heatmap: 6,
    Extrusion: 12,
    DataView: 14,
    Collection: 29,
    LocalLayer: 50,
    Georeference: 59,
    MBTilesCollection: 107,
    DocumentsCollection: 106,
    PointCloud: 135,
    Folder: 136,
    RasterVideo: 176,
    RasterDem: 138,
    RasterImage: 179,
    OrganizationCollection: 194,
    Tile3D: 259,
    Terrain: 260,
    Object3D: 261,
    Polygon3D: 262,
    Potree: 281,
    Traffic: 269,
    Geojson: 271,
    Stations: 272,
    Routes: 273,
    PointOfInterest: 274,
    Vehicles: 275,
    StreetLight: 277,
    Line3D:278,
    Point3D:279,
    Isochrone:295,
    DataSourceCollection: 296

  };
  static InternalDocumentTypes = [this.DocumentTypes.Sky, this.DocumentTypes.Relief, this.DocumentTypes.Style];

  static Icons = {
    'auto-aim': AutoAIM,
    'map-pin': MapPin,
    'map-pin-secondary': MapPinSecondary,
    'map-check': MapCheck,
    'map-move': MapMove,
    'map-rotate': MapRotate,
    'map-trash': MapTrash,
    'georef-map-point-success': GeoRefMapPointSuccess,
    'georef-map-point-warn': GeoRefMapPointWarn,
    'georef-map-point-error': GeoRefMapPointError,
    'georef-canvas-point-success': GeoRefCanvasPointSuccess,
    'georef-canvas-point-warn': GeoRefCanvasPointWarn,
    'georef-canvas-point-error': GeoRefCanvasPointError,
    'aim1': MapAIM1,
    'aim2': MapAIM2,
    'aim3': MapAIM3,
    'aim4': MapAIM4,
    'aim5': MapAIM5,
    'aim6': MapAIM6,
    'aim7': MapAIM7,
    'aim8': MapAIM8,
    'aim9': MapAIM9,
    'aim10': MapAIM10,
    'aim11': MapAIM11,
    'aim12': MapAIM12,
    'aim13': MapAIM13,
    'aim14': MapAIM14,
    'aim15': MapAIM15,
    'aim16': MapAIM16,
    'aim17': MapAIM17,
    'aim18': MapAIM18,
    'aim19': MapAIM19,
    'aim20': MapAIM20,
  }

  static extractImagesFromLayer(layerProperties, layerType) {
    return extractImagesFromLayer(layerProperties, layerType);
  }

  static filterMapboxPropsByType(object, layerType, propertyType) {
    return filterMapboxPropsByType(object, layerType, propertyType);
  }

  static normalizeStyle(style, layerType, propertyType, overwriteValues = undefined) {
    return normalizeStyle(style, layerType, propertyType, overwriteValues);
  }

  static extractLabelImages(layerProperties, attribute, colorAttribute) {
    return extractLabelImages(layerProperties, attribute, colorAttribute);
  }

  static apiBaseUrl(version: string = 'v1') {
    return apiBaseUrl(version);
  }

  static isLocalLayer(layer?) {
    return layer?.properties?.dataSource?.isLocal;
  }
}
